export default {
  drawer: null,
  color: 'info',
  breadcrumbs: [],
  snackbarState: false,
  snackbarMessage: '',
  snackbarColor: ''
}
